import { AloftPrice, PairedCostAdjustments } from '@aloft/toolkit-shared';

import { get } from 'lodash';

import { Tkv2OrderContext } from '../../../../controller/types.js';

export const getAdjustment = (
  context: Tkv2OrderContext,
  compID: string,
  adjustmentKey: keyof PairedCostAdjustments,
): AloftPrice | undefined =>
  get(context, `pairedCostResults.comps.${compID}.adjustments.${adjustmentKey}.adjustment`);
